import React from "react";
import { Modal, Button, Row, Col } from "react-bootstrap"; // Correct imports for LedgerViewModal
import ModalCloseButton from "../ModalCloseButton";
import guLocale from "../../locales/gu";

const AdminUserViewModal = ({ show, handleClose, initialData }) => {
  const locale = guLocale.admin.user;
  const ledgerData = initialData || {};
  const handleModalClose = () => {
    handleClose();
  };

  return (
    <Modal show={show} onHide={handleClose} size="lg">
      <Modal.Header>
        <Modal.Title>{locale.modalTitle}</Modal.Title>
        <ModalCloseButton onClick={handleModalClose} />
      </Modal.Header>
      <Modal.Body>
      <Row className="mb-3">
            <Col md={6}>
            <div>
              <label className="form-label fw-bold">{locale.mobileNoLabel}</label>
              <div className="border p-2 bg-light">{ledgerData.mobile_no}</div>
            </div>
          </Col>
          <Col md={6}>
            <div>
              <label className="form-label fw-bold">{locale.businessEmailLabel}</label>
              <div className="border p-2 bg-light">{ledgerData.business_email}</div>
            </div>
          </Col>
        </Row>
        <Row className="mb-3">
          <Col md={6}>
            <div>
              <label className="form-label fw-bold">{locale.brcFullNameLabel}</label>
              <div className="border p-2 bg-light">{ledgerData.brc_full_name}</div>
            </div>
          </Col>
          <Col md={6}>
            <div>
              <label className="form-label fw-bold">{locale.schoolNameLabel}</label>
              <div className="border p-2 bg-light">{ledgerData.school_name}</div>
            </div>
          </Col>
        </Row>
        <Row className="mb-3">
          <Col md={6}>
            <div>
              <label className="form-label fw-bold">{locale.schoolDiceCodeLabel}</label>
              <div className="border p-2 bg-light">{ledgerData.school_dice_code}</div>
            </div>
          </Col>
          <Col md={6}>
            <div>
              <label className="form-label fw-bold">{locale.rojmelNameLabel}</label>
              <div className="border p-2 bg-light">{ledgerData.rojmel_name}</div>
            </div>
          </Col>
        </Row>
        <Row className="mb-3">
          <Col md={6}>
            <div>
              <label className="form-label fw-bold">{locale.clusterNameLabel}</label>
              <div className="border p-2 bg-light">{ledgerData.cluster_name}</div>
            </div>
          </Col>
          <Col md={6}>
            <div>
              <label className="form-label fw-bold">{locale.blockNameLabel}</label>
              <div className="border p-2 bg-light">{ledgerData.block_name}</div>
            </div>
          </Col>
        </Row>
        <Row className="mb-3">
          <Col md={6}>
            <div>
              <label className="form-label fw-bold">{locale.bankNameLabel}</label>
              <div className="border p-2 bg-light">{ledgerData.bank_name}</div>
            </div>
          </Col>
          <Col md={6}>
            <div>
              <label className="form-label fw-bold">{locale.bankBranchNameLabel}</label>
              <div className="border p-2 bg-light">{ledgerData.bank_branch_name}</div>
            </div>
          </Col>
        </Row>
        <Row className="mb-3">
          <Col md={6}>
            <div>
              <label className="form-label fw-bold">{locale.bankAccountNoLabel}</label>
              <div className="border p-2 bg-light">{ledgerData.bank_account_no}</div>
            </div>
          </Col>
          <Col md={6}>
            <div>
              <label className="form-label fw-bold">{locale.addressLabel}</label>
              <div className="border p-2 bg-light">{ledgerData.address}</div>
            </div>
          </Col>
        </Row>
        <Row className="mb-3">
            <Col md={6}>
            <div>
              <label className="form-label fw-bold">{locale.districtLabel}</label>
              <div className="border p-2 bg-light">{ledgerData.district}</div>
            </div>
          </Col>
          <Col md={6}>
            <div>
              <label className="form-label fw-bold">{locale.subDivisionLabel}</label>
              <div className="border p-2 bg-light">{ledgerData.sub_division}</div>
            </div>
          </Col>
        </Row>
        <Row className="mb-3">
          <Col md={6}>
            <div>
              <label className="form-label fw-bold">{locale.pincodeLabel}</label>
              <div className="border p-2 bg-light">{ledgerData.pincode}</div>
            </div>
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleModalClose}>
          {locale.closeButtonText}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AdminUserViewModal;